module.exports = "img/icon-text-cancel.900cf21.svg";